import type { ReactNode } from 'react';
import { acquisitionLabels } from '../../data/acquisition';
import { ACQUISITION_CHANNELS, SOURCE_OTHER_MAX } from '../../core/rules/acquisition';
import { chipCls, inputCls } from '../../ui/styles';
import type { AcquisitionChannel, AcquisitionSource } from '../../core/types/insights';
type Props = {
  /** Uniek per plek: voor het label van het vrije-tekstveld. */
  id: string;
  value: AcquisitionSource | null;
  onChange: (next: AcquisitionSource | null) => void;
  legend: ReactNode;
  legendClassName?: string;
  hint?: string;
  disabled?: boolean;
  /** Na een tik op een vaste keuze (niet "Anders"), bijv. meteen versturen op de bedankpagina. */
  onPick?: (source: AcquisitionSource) => void;
};

/**
 * "Hoe kwam je bij ons?" als rij keuzes: één tik, nog eens tikken = leeg. "Anders" vraagt om een
 * korte toelichting (hoogstens 60 tekens). Nooit verplicht; de plek die dit toont, zegt dat ook.
 */
export function SourceChips({
  id,
  value,
  onChange,
  legend,
  legendClassName = 'text-[15px] text-ink',
  hint,
  disabled = false,
  onPick
}: Props) {
  const pick = (channel: AcquisitionChannel) => {
    if (value?.channel === channel) return onChange(null);
    const next = {
      channel
    };
    onChange(next);
    if (channel !== 'anders') onPick?.(next);
  };
  return <fieldset disabled={disabled} data-id="element-8754" data-mp="27mh1pm3wdu7f">
      <legend className={legendClassName} data-id="element-8755" data-mp="27lfekj9lxh9c">{legend}</legend>
      {hint && <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-8756" data-mp="19yyjlkocjfqr">{hint}</p>}
      <div className="mt-3 flex flex-wrap gap-2" data-id="element-8757" data-mp="1a0t44xvph5ub">
        {ACQUISITION_CHANNELS.map(c => <button key={c} type="button" aria-pressed={value?.channel === c} onClick={() => pick(c)} className={`${chipCls(value?.channel === c)} disabled:opacity-60`} data-id="element-8758" data-mp="1ezw3c1p08hud">
            {acquisitionLabels[c]}
          </button>)}
      </div>
      {value?.channel === 'anders' && <div className="mt-3 max-w-sm" data-id="element-8759" data-mp="2vbrxep6e4yep">
          <label htmlFor={`${id}-anders`} className="mb-1.5 block text-[13px] text-muted" data-id="element-8760" data-mp="30aw67epeku4i">
            Waar dan? <span data-id="element-8761" data-mp="108mv1nqqeljz">(hoeft niet)</span>
          </label>
          <input id={`${id}-anders`} value={value.other ?? ''} onChange={e => onChange({
        channel: 'anders',
        other: e.target.value.slice(0, SOURCE_OTHER_MAX)
      })} maxLength={SOURCE_OTHER_MAX} autoComplete="off" className={inputCls} data-id="element-8762" data-mp="1071zpvwleyl2" />
        </div>}
    </fieldset>;
}